import { prepareCommonShaftData } from "./sendShaftCommon";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type LinearConfigurationUpdate } from "../../Linear/models";
import { sendShaft } from "./sendShaftCommon";

export function sendShaftStepChange(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonShaftData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";

  return sendShaft(data);
}

export const sendShaftMiscChange = sendShaftStepChange;
